<!-- TODO: A supprimer quand l'implémentation v10 sera terminée -->
<custom-frame [frame]="'domaines'" [isTitleHidden]="true"></custom-frame>
